var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Rewards Analytics","icon":"gift","css-class":"analytics-rewards","default-label":"Rewards","section-specs":_setup.sectionSpecs}},[_c(_setup.RewardsMetrics,{ref:"rewardsRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }